import { Box, Icon, Typography } from '@mui/material'
import React from 'react'

// Shows that an employee has approved claims waiting, or how much is included in this payroll
const ClaimBadge = ({ summary, sx }) => {
  if (!summary) return null

  const label =
    summary.included_count > 0
      ? `Claims RM ${Number(summary.included_amount).toFixed(2)} included`
      : `${summary.available} claim${summary.available > 1 ? 's' : ''} to review`

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, ...sx }}>
      <Icon sx={{ fontSize: 16, color: 'alternate.main' }}>attach_file</Icon>
      <Typography variant="caption" color="alternate.main">
        {label}
      </Typography>
    </Box>
  )
}

export default ClaimBadge
